import { Scene } from "../internal";
import { DOM } from "../utils/DOM";
import { DOMRenderer } from "./DOMRenderer";
import { KeyboardService } from "./KeyboardService";
import { MouseService } from "./MouseService";
import { RenderService } from "./RenderService";
import { AuthMode } from "./AuthMode";
export class Container {
    constructor(options, navigator, dom) {
        this._dom = dom ? dom : new DOM();
        if (typeof options.container === "string") {
            this._container = this._dom.document.getElementById(options.container);
            if (!this._container) {
                throw new Error(`Container "${options.container}" not found.`);
            }
            else {
                this._container.innerHTML = "";
            }
        }
        else if (options.container instanceof HTMLElement) {
            this._container = options.container;
        }
        else {
            throw new Error(`Invalid type: "container" must be a String or HTMLElement.`);
        }
        this.id = this._container.id ? this._container.id : "infra3dsdk-fallback-container-id";
        this._container.classList.add("infra3dsdk-viewer");
        this._canvasContainer = this._dom.createElement("div", "infra3dsdk-interactive", this._container);
        this._canvas = this._dom.createElement("canvas", "infra3dsdk-canvas");
        this._canvas.style.position = "absolute";
        this._canvas.setAttribute("tabindex", "0");
        // Add DOM container after canvas container to render DOM
        // elements on top of the interactive canvas.
        this._domContainer = this._dom.createElement("div", "infra3dsdk-dom", this._container);
        //Parse the authMode out of the viewer options
        let authMode = AuthMode.view;
        if (options.authMode !== undefined) {
            authMode = options.authMode;
            if (typeof options.authMode === "string") {
                authMode = AuthMode[options.authMode];
            }
            else {
                authMode = options.authMode;
            }
        }
        // TODO: Abstract.
        this.scene = new Scene(this._canvasContainer, this._canvas, this._canvasContainer, options.imageProvider, options.authObject, authMode);
        this.renderService = new RenderService(this.scene, navigator, this._container);
        this.domRenderer = new DOMRenderer(this._domContainer, this.renderService, navigator.stateService.currentState$);
        this.keyboardService = new KeyboardService(document);
        this.mouseService = new MouseService(this._container, this._canvasContainer, this._domContainer, document);
        this._resizeSubscription = this.renderService.size$.subscribe((size) => {
            this.scene.resize(size.width, size.height);
        });
        //only needed for panodepthmapintersction.. to query related depthmaps. maybe do this different.
        this.scene.setNavigator(navigator);
    }
    get canvas() {
        return this._canvas.parentNode ? this._canvas : null;
    }
    get canvasContainer() {
        return this._canvasContainer;
    }
    get container() {
        return this._container;
    }
    get domContainer() {
        return this._domContainer;
    }
    remove() {
        this._removeNode(this._canvasContainer);
        this._removeNode(this._domContainer);
        this._container.classList.remove("infra3dsdk-viewer");
    }
    _removeNode(node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
}
//# sourceMappingURL=Container.js.map